module.exports = __webpack_public_path__ + "img/nol-back.71c45792.png";